// extracted by mini-css-extract-plugin
module.exports = {"container":"PageWarning_container__H3YSJ","warning":"PageWarning_warning__e9mRa","whiteBg":"PageWarning_whiteBg__OXJpE"};